const rankings = [
  {
    rank: 1,
    title: '暗网入门完全指南（2026最新版）',
    desc: '最全面的暗网新手入门教程，涵盖从概念到实操的全部内容。阅读量持续领先。',
    hot: true,
    icon: 'ri-book-open-line',
  },
  {
    rank: 2,
    title: 'Tor浏览器下载安装配置全流程',
    desc: '多平台Tor浏览器安装教程，包含安全级别设置与常见问题排查。',
    hot: true,
    icon: 'ri-window-line',
  },
  {
    rank: 3,
    title: '暗网安全访问防护方案推荐',
    desc: 'VPN搭配、系统加固、PGP加密一步到位，暗网安全访问的黄金标准方案。',
    hot: true,
    icon: 'ri-shield-keyhole-line',
  },
  {
    rank: 4,
    title: '2026年最新暗网网址导航合集',
    desc: '人工验证的最新可用.onion网址，分类清晰，每周更新确保链接有效性。',
    hot: false,
    icon: 'ri-link',
  },
  {
    rank: 5,
    title: '暗网吃瓜爆料：近期热点事件追踪',
    desc: '投稿精选与社区动态汇总，暗网世界最热门话题一站式追踪。',
    hot: true,
    icon: 'ri-fire-line',
  },
  {
    rank: 6,
    title: '暗网深度网搜索引擎使用评测',
    desc: '主流暗网搜索引擎横向对比，告诉你哪个最适合中文用户使用。',
    hot: false,
    icon: 'ri-search-eye-line',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          暗网社区最受欢迎的内容排行，看看大家都在读什么
        </p>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 border border-background-200/60 rounded-lg p-4 group transition-all duration-200"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 font-heading text-lg font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500/10 text-primary-400'
                  : 'bg-background-200/50 text-foreground-500'
              }`}>
                {item.rank <= 3 ? (
                  <i className={`text-lg ${item.rank === 1 ? 'ri-trophy-line text-primary-400' : item.rank === 2 ? 'ri-medal-line text-secondary-400' : 'ri-medal-line text-accent-400'}`}></i>
                ) : (
                  item.rank
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm font-semibold text-foreground-100 truncate group-hover:text-primary-400 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs truncate mt-0.5">{item.desc}</p>
              </div>
              {item.hot && (
                <span className="shrink-0 px-2.5 py-1 bg-accent-500/10 text-accent-400 text-[10px] font-medium rounded-full whitespace-nowrap">
                  热门
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}